import { createFileRoute } from "@tanstack/react-router";
import Demo from "@/pages/Demo";

export const Route = createFileRoute("/demo")({
  head: () => ({
    meta: [
      { title: "Gratis demo aanvragen | De Hussel App" },
      { name: "description", content: "Vraag een gratis demo aan van De Hussel App. Ontdek hoe je automatische hussel-indelingen maakt voor je tennisclub." },
      { property: "og:title", content: "Gratis demo aanvragen | De Hussel App" },
      { property: "og:description", content: "Vraag een gratis demo aan van De Hussel App. Ontdek hoe je automatische hussel-indelingen maakt voor je tennisclub." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/demo" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/demo" }],
  }),
  component: Demo,
});
